import { NavNotificationBadge } from "@/features/onboarding/hooks/usePatientNotificationCounts";
import { useMyPendingValidationCount } from "@/features/validations/api/selectMyPendingValidations";
import { useAuth } from "@/utils/auth";

const ValidationNotificationCount = () => {
    const auth = useAuth();
    const { data: count = 0 } = useMyPendingValidationCount(auth.id ?? "");

    return <NavNotificationBadge count={count} />;
};

export default ValidationNotificationCount;
